export default __webpack_public_path__ + "static/media/h60mc.4b2dc67a.jpg";